import React from 'react';
import classNames from 'classnames';
import { formatPurchaseAmount } from '../purchaseHelpers';

export default function PurchasePricing({ plans, onSelectPlan }) {
  return (
    <div className="purchase-pricing">
      <p className="purchase-eyebrow">Pricing</p>
      <h1 className="purchase-title">Choose your Continuity Plan</h1>
      <p className="purchase-subtitle">
        Purchase for yourself or for your client. A single plan covers one business location — add expert
        guidance whenever you want it.
      </p>
      <div className="purchase-accent-line" aria-hidden="true" />

      <div className="purchase-plan-grid">
        {plans.map((plan) => (
          <article
            key={plan.id}
            className={classNames('purchase-plan-card', {
              'purchase-plan-card--featured': plan.featured,
            })}
          >
            {plan.popularLabel ? (
              <span className="purchase-plan-popular">{plan.popularLabel}</span>
            ) : null}

            {plan.badge?.label ? (
              <span className={classNames('purchase-plan-badge', `purchase-plan-badge--${plan.badge.tone}`)}>
                {plan.badge.label}
              </span>
            ) : null}

            <h2 className="purchase-plan-name">{plan.name}</h2>
            <p className="purchase-plan-description">{plan.description}</p>

            <div className="purchase-plan-price">
              <span className="purchase-plan-price-amount">
                {formatPurchaseAmount(plan.price, plan.currencyCode, plan.currencySymbol)}
              </span>
              {plan.currencyCode ? (
                <span className="purchase-plan-price-currency">{plan.currencyCode}</span>
              ) : null}
              <span className="purchase-plan-price-interval">one-time</span>
            </div>

            <ul className="purchase-plan-features">
              {plan.features.map((feature) => (
                <li key={feature}>{feature}</li>
              ))}
            </ul>

            <button
              type="button"
              className={classNames('purchase-plan-cta', {
                'purchase-plan-cta--primary': plan.featured,
              })}
              onClick={() => onSelectPlan(plan)}
            >
              {plan.ctaLabel}
            </button>
          </article>
        ))}
      </div>

      <p className="purchase-footer-note">
        Once purchased, an email will be sent to your nominated address to get started.
        <br />
        All plans are one-time payments · No subscriptions · Secured via PayPal
      </p>
    </div>
  );
}
